import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styled from 'styled-components'
import { FEED_RESET } from '../../../../redux/constants'

import { fetchFeed, setAttr } from '../../../../redux/feedInfiniteSlice'
import FilterSelections from './FilterSelections'
import { Pill } from './FilterPills'
const categories = require('../../../../redux/data/categories.json')

const FilterGroup = styled.div`
  margin-top: 14px;
  margin-left: 16px;
  margin-right: 16px;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: ${props => (props.size === 180 ? 'column' : 'row')};
  justify-content: stretch;
  align-items: stretch;
  align-self: stretch;
  /*gap: 14px;*/
`

const FilterItemLeft = styled.div`
  position: relative;
  flex: 1 1 0px;
  margin-right: ${props => (props.size === 180 ? '0px' : '7px')};
  margin-bottom: ${props => (props.size === 180 ? '7px' : '0px')};
`

const FilterItemRight = styled.div`
  position: relative;
  flex: 1 1 0px;
  height: 30px;
  margin-left: ${props => (props.size === 180 ? '0px' : '7px')};
`

const FilterBar = ({ toggleSelectVisible, isSelectVisible, ...props }) => {
  const dispatch = useDispatch()
  const { menuWidth } = useSelector(state => state.workspace)
  const { attr } = useSelector(state => state.mydecor)

  const categoryName = attr?.addition?.category
  const category = categoryName
    ? categories.find(c => c.name === categoryName)
    : null

  const handlePillRemove = e => {
    dispatch(setAttr('mydecor')({ addition: {} }))
    dispatch(fetchFeed('mydecor')({ status: FEED_RESET }))
  }

  return (
    <>
      <FilterGroup size={menuWidth} {...props}>
        <FilterItemLeft size={menuWidth}>
          <FilterSelections
            show={isSelectVisible}
            onClick={toggleSelectVisible}
          />
        </FilterItemLeft>
        <FilterItemRight size={menuWidth}>
          {category && (
            <Pill
              onClick={handlePillRemove}
              data={{ label: category.shortName }}
            />
          )}
        </FilterItemRight>
      </FilterGroup>
    </>
  )
}

export default FilterBar
